import classnames from 'classnames';
import React from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';

export default class Accordion extends React.PureComponent {
  render() {
    const {
      open,
      style,
      content,
      timeout,
      children,
      className,
      afterContent,
      beforeContent,
      animationClass,
      forceRenderContent,
      transitionComponentRef,
      accordionId,
    } = this.props;

    return (
      <div>
        <Transition in={open} timeout={timeout} key={accordionId}>
          {(state) => (
            <div
              style={style}
              ref={transitionComponentRef}
              className={classnames('new-accordion', className, {
                [animationClass]: animationClass,
                [`${animationClass}-${state}`]: animationClass,
              })}>
              {beforeContent}
              {forceRenderContent || state !== 'exited' ? content || children : null}
              {afterContent}
            </div>
          )}
        </Transition>
      </div>
    );
  }
}

Accordion.defaultProps = {
  timeout: 300,
};
Accordion.propTypes = {
  open: PropTypes.bool.isRequired,
  accordionId: PropTypes.string,
  style: PropTypes.object,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  timeout: PropTypes.number,
  className: PropTypes.string,
  afterContent: PropTypes.element,
  beforeContent: PropTypes.element,
  animationClass: PropTypes.string,
  forceRenderContent: PropTypes.bool,
  transitionComponentRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};
